/** useServizi + mutations (create/update/delete) — F-009.6 admin. */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import {
  getServizi,
  createServizio,
  updateServizio,
  deleteServizio,
  errorMessageFor,
  type ServiziListResponse,
  type CreateServizioBody,
  type UpdateServizioBody,
} from '../lib/servizi-client';
import { serviziQueryKey } from '../lib/query-client';

export function useServizi() {
  return useQuery<ServiziListResponse>({ queryKey: serviziQueryKey, queryFn: getServizi });
}

export function useCreateServizio() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: CreateServizioBody) => createServizio(body),
    onSuccess: () => {
      toast.success('Servizio creato.');
      void qc.invalidateQueries({ queryKey: serviziQueryKey });
    },
    onError: (err) => toast.error(errorMessageFor(err)),
  });
}

export function useUpdateServizio() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: string; body: UpdateServizioBody }) =>
      updateServizio(vars.id, vars.body),
    onSuccess: () => {
      toast.success('Servizio aggiornato.');
      void qc.invalidateQueries({ queryKey: serviziQueryKey });
    },
    onError: (err) => toast.error(errorMessageFor(err)),
  });
}

export function useDeleteServizio() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deleteServizio(id),
    onSuccess: () => {
      toast.success('Servizio eliminato.');
      void qc.invalidateQueries({ queryKey: serviziQueryKey });
    },
    onError: (err) => toast.error(errorMessageFor(err)),
  });
}
